import React, { useState, useEffect, useRef } from 'react'
import './styles/intro.css'
import { TITLES, INTRO_TEXT} from '../constants.js'


export default function Intro() {

  const titleRef = useRef(null);
  const bioRef = useRef(null);

  const [titleVisible, setTitleVisible] = useState(false);
  const [bioVisible, setBioVisible] = useState(false);

  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  const [text, setText] = useState("");
  const [typingIndex, setTypingIndex] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.3
    };

    const titleVisible = new IntersectionObserver(([entry]) => {
      setTitleVisible(entry.isIntersecting);
    }, observerOptions);

    const bioVisible = new IntersectionObserver(([entry]) => {
      setBioVisible(entry.isIntersecting);
    }, observerOptions);

    if (titleRef.current) titleVisible.observe(titleRef.current);
    if (bioRef.current) bioVisible.observe(bioRef.current);

    return () => {
      titleVisible.disconnect();
      bioVisible.disconnect();
    };
  }, []);


  // title timer
  useEffect(() => {

    if (!titleVisible) return;

    const interval = setInterval(() => {
    setFade(false);

    setTimeout(() => {
        setIndex((prev) => (prev + 1) % TITLES.length);
        setFade(true);
    }, 400);
    }, 2500);

    return () => clearInterval(interval);
    }, [titleVisible]);

    // bio timer
  useEffect(() => {
    
    if (!bioVisible) return;

    const speed = deleting ? 40 : 25;

    const timer = setTimeout(() => {
      if (!deleting && typingIndex < INTRO_TEXT.length) {
        setText(INTRO_TEXT.slice(0, typingIndex + 1));
        setTypingIndex((v) => v + 1);
      } else if (!deleting && typingIndex === INTRO_TEXT.length) {
        setTimeout(() => setDeleting(true), 2000);
      } else if (deleting && typingIndex > 0) {
        setText(INTRO_TEXT.slice(0, typingIndex - 1));
        setTypingIndex((v) => v - 1);
      } else if (deleting && typingIndex === 0) {
        setDeleting(false);
      }
    }, speed);

    return () => clearTimeout(timer);
    }, [typingIndex, bioVisible, deleting]);
    
    return (
  <section id="intro" className="section">
    <div className="intro-container">
      <div className="intro-text">
        <h1>Eric</h1>

        <h2 ref={titleRef} className={`intro-title ${fade ? "fade-in" : "fade-out"}`}>
          {TITLES[index]}
        </h2>

          <p ref={bioRef} className="typewriter">
          {text}<span className="cursor">|</span>
        </p>

        <div id="intro-nav">
          <div id="intro-btn-container">
            <a href="#contact">Contact Me</a>
            <a href="#about">Learn More</a>
          </div>
        </div>
      </div>

        <div className="intro-image">
          <figure>
            <img src="/portrait.png" alt="Asian man smiling too much" />
            <figcaption><span>{"📸 @L.Nguyen"}</span></figcaption>
          </figure>
      </div>
    </div>
  </section>
);
}